// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xvJX","questions":"styles_questions__liko0","footer":"styles_footer__2sa-p"};